import { assistantConstant } from "@constants";

export function getAssistantByid (state = {}, action) {
    switch (action.type) {
        case assistantConstant.LOAD_TIP_MESSAGE_BY_ID_REQUEST:
            return { 
                ...state,
                isLoading: true 
            };
        case assistantConstant.LOAD_TIP_MESSAGE_BY_ID_SUCCESS:
            return {
                ...state,
                data: action.payload,
                isLoading: false
            };
        case assistantConstant.LOAD_TIP_MESSAGE_BY_ID_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        default: return state;
    }
};